var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecrypt0105(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34DAE2;}\n\t.st1{fill:#252A41;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#252A41;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    className: "st1",
    d: "M4.8,8.86c-0.75,0-1.36,0.61-1.36,1.36v6.34c-0.02,0.75,0.57,1.38,1.32,1.4 c0.75,0.02,1.38-0.57,1.4-1.32c0-0.02,0-0.05,0-0.07v-6.34C6.16,9.47,5.55,8.86,4.8,8.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    className: "st1",
    d: "M20.2,8.86c-0.75,0-1.36,0.61-1.36,1.36l0,0v6.34c-0.02,0.75,0.57,1.37,1.32,1.4 s1.37-0.57,1.4-1.32c0-0.02,0-0.05,0-0.07v-6.34C21.56,9.47,20.95,8.86,20.2,8.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    className: "st1",
    d: "M17.48,8.86H7.52c-0.25,0-0.45,0.2-0.45,0.45l0,0v7.25c0,1.08,0.76,2,1.81,2.22v3.22 c0.02,0.75,0.65,1.34,1.4,1.32c0.72-0.02,1.3-0.6,1.32-1.32v-3.17h1.81v3.17c-0.02,0.75,0.57,1.38,1.32,1.4s1.38-0.57,1.4-1.32 c0-0.02,0-0.05,0-0.07v-3.22c1.05-0.22,1.81-1.14,1.81-2.22V9.31C17.93,9.06,17.73,8.86,17.48,8.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.79,3.49l1.1-1.1c0.18-0.17,0.19-0.46,0.02-0.64s-0.46-0.19-0.64-0.02c0,0,0,0-0.01,0.01l-0.01,0.01 l-1.29,1.29c-1.58-0.68-3.36-0.68-4.94,0L8.75,1.75C8.56,1.58,8.27,1.59,8.11,1.78c-0.16,0.17-0.16,0.44,0,0.61l1.1,1.1 C7.86,4.38,7.06,5.88,7.06,7.5c0,0.25,0.2,0.45,0.45,0.45h9.96c0.25,0,0.45-0.2,0.45-0.45C17.94,5.89,17.14,4.38,15.79,3.49z  M10.24,6.14c-0.25,0-0.45-0.2-0.45-0.45s0.2-0.45,0.45-0.45s0.45,0.2,0.45,0.45S10.49,6.14,10.24,6.14z M14.77,6.14 c-0.25,0-0.45-0.2-0.45-0.45s0.2-0.45,0.45-0.45s0.45,0.2,0.45,0.45S15.02,6.14,14.77,6.14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecrypt0105);
export default __webpack_public_path__ + "static/media/recrypt_01-05.967b7673.svg";
export { ForwardRef as ReactComponent };